const ExportFileButton = () => import('./ExportFileButton')

export default function install(Vue) {
  Vue.component('export-file-button', ExportFileButton)
}
